import api from './axiosConfig';

interface LoginAttempt {
  hour: number;
  count: number;
}

class LoginAttempts {
  private static instance: LoginAttempts;

  private constructor() {}

  static getInstance() {
    if (!LoginAttempts.instance) {
      LoginAttempts.instance = new LoginAttempts();
    }
    return LoginAttempts.instance;
  }

  async getLoginAttempts(date: string) {
    // Formatear la fecha para asegurar que esté en formato ISO
    const formattedDate = new Date(date).toISOString().split('T')[0];
    const response = await api.get<LoginAttempt[]>(
      `loginattemptsbyhour?date=${formattedDate}`
    );
    return response.data;
  }
}

export default LoginAttempts.getInstance();
